import { useEffect, useState } from "react";
import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";

let launchDarklyReady = false;

export function resetTermsFeatureFlagReadyForTests(): void {
  launchDarklyReady = false;
}

export function useTermsFeatureFlag(): {
  featureEnabled: boolean;
  flagReady: boolean;
} {
  const { allowTermsAndConditions } = useFlags();
  const ldClient = useLDClient();
  const [flagReady, setFlagReady] = useState(launchDarklyReady);

  useEffect(() => {
    if (launchDarklyReady) {
      setFlagReady(true);
      return;
    }

    if (!ldClient) {
      return;
    }

    let cancelled = false;
    ldClient.waitUntilReady().then(() => {
      launchDarklyReady = true;
      if (!cancelled) {
        setFlagReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [ldClient]);

  return {
    featureEnabled: flagReady && allowTermsAndConditions === true,
    flagReady,
  };
}
